
// Retrieve Projects
export const GET_PROJECTS_START = "GET_PROJECTS_START";
export const GET_PROJECTS_SUCCESS = "GET_PROJECTS_SUCCESS";
export const GET_PROJECTS_FAILURE = "GET_PROJECTS_FAILURE";

// Retrieve single Project
export const GET_PROJECT_START = "GET_PROJECT_START";
export const GET_PROJECT_SUCCESS = "GET_PROJECT_SUCCESS";
export const GET_PROJECT_FAILURE = "GET_PROJECT_FAILURE";

export const OPEN_PROJECT_FORM = "OPEN_PROJECT_FORM";
export const CLOSE_PROJECT_FORM = "CLOSE_PROJECT_FORM";

// Create Project
export const CREATE_PROJECT_START = 'CREATE_PROJECT_START';
export const CREATE_PROJECT_SUCCESS = 'CREATE_PROJECT_SUCCESS';
export const CREATE_PROJECT_FAILURE = 'CREATE_PROJECT_FAILURE';

// Update exiting Project
export const UPDATE_PROJECT_START = 'UPDATE_PROJECT_START';
export const UPDATE_PROJECT_SUCCESS = 'UPDATE_PROJECT_SUCCESS';
export const UPDATE_PROJECT_FAILURE = 'UPDATE_PROJECT_FAILURE';

// Delete exiting Project
export const DELETE_PROJECT_START = 'DELETE_PROJECT_START';
export const DELETE_PROJECT_SUCCESS = 'DELETE_PROJECT_SUCCESS';
export const DELETE_PROJECT_FAILURE = 'DELETE_PROJECT_FAILURE';

// Retrieve regions
export const GET_REGIONS_START = 'GET_REGIONS_START';
export const GET_REGIONS_SUCCESS = 'GET_REGIONS_SUCCESS';
export const GET_REGIONS_FAILURE = 'GET_REGIONS_FAILURE';

// Retrieve districts
export const GET_DISTRICTS_START = 'GET_DISTRICTS_START';
export const GET_DISTRICTS_SUCCESS = 'GET_DISTRICTS_SUCCESS';
export const GET_DISTRICTS_FAILURE = 'GET_DISTRICTS_FAILURE';

// Retrieve locations
export const GET_LOCATIONS_START = 'GET_LOCATIONS_START';
export const GET_LOCATIONS_SUCCESS = 'GET_LOCATIONS_SUCCESS';
export const GET_LOCATIONS_FAILURE = 'GET_LOCATIONS_FAILURE';

// Retrieve environmental categories
export const GET_ENVIRONMENTAL_CATEGORIES_START = 'GET_ENVIRONMENTAL_CATEGORIES_START';
export const GET_ENVIRONMENTAL_CATEGORIES_SUCCESS = 'GET_ENVIRONMENTAL_CATEGORIES_SUCCESS';
export const GET_ENVIRONMENTAL_CATEGORIES_FAILURE = 'GET_ENVIRONMENTAL_CATEGORIES_FAILURE';

// select vendor
export const SELECT_PROJECT = 'SELECT_PROJECT';



// select vendor
export const SELECT_SUB_PROJECT = 'SELECT_SUB_PROJECT';

// Create Project location
export const CREATE_PROJECT_LOCATION_START = 'CREATE_PROJECT_LOCATION_START';
export const CREATE_PROJECT_LOCATION_SUCCESS = 'CREATE_PROJECT_LOCATION_SUCCESS';
export const CREATE_PROJECT_LOCATION_FAILURE = 'CREATE_PROJECT_LOCATION_FAILURE';

export const GET_ITEMS_START= 'GET_ITEMS_START';
export const GET_ITEMS_SUCCESS = 'GET_ITEMS_SUCCESS';
export const GET_ITEMS_FAILURE = 'GET_ITEMS_FAILURE';

export const GET_PROGRESS_START= 'GET_PROGRESS_START';
export const GET_PROGRESS_SUCCESS = 'GET_PROGRESS_SUCCESS';
export const GET_PROGRESS_FAILURE = 'GET_PROGRESS_FAILURE';

// Retrieve Projects
export const GET_PROJECT_STATUS_START = "GET_PROJECT_STATUS_START";
export const GET_PROJECT_STATUS_SUCCESS = "GET_PROJECT_STATUS_SUCCESS";
export const GET_PROJECT_STATUS_FAILURE = "GET_PROJECT_STATUS_FAILURE";

// project filter types
export const SET_PROJECT_STATUS_FILTER = "SET_PROJECT_STATUS_FILTER";
export const SET_PROJECT_ID_FILTER = "SET_PROJECT_ID_FILTER";
export const SET_PROJECT_REGIONS_FILTER = "SET_PROJECT_REGIONS_FILTER";

// Getting project
export const GET_PROJECTS_FILTER_START = "GET_PROJECTS_FILTER_START";
export const GET_PROJECTS_FILTER_SUCCESS = "GET_PROJECTS_FILTER_SUCCESS";
export const GET_PROJECTS_FILTER_FAILURE = "GET_PROJECTS_FILTER_FAILURE";

// search projects
export const SEARCH_PROJECTS = "SEARCH_PROJECTS";

// Getting layers
export const GET_LAYERS_START = "GET_LAYERS_START";
export const GET_LAYERS_SUCCESS = "GET_LAYERS_SUCCESS";
export const GET_LAYERS_FAILURE = "GET_LAYERS_FAILURE";

// Create Project Components
export const CREATE_PROJECT_COMPONENT_START = 'CREATE_PROJECT_COMPONENT_START';
export const CREATE_PROJECT_COMPONENT_SUCCESS = 'CREATE_PROJECT_COMPONENT_SUCCESS';
export const CREATE_PROJECT_COMPONENT_FAILURE = 'CREATE_PROJECT_COMPONENT_FAILURE';

// Create Project SubComponents
export const CREATE_PROJECT_SUB_COMPONENT_START = 'CREATE_PROJECT_SUB_COMPONENT_START';
export const CREATE_PROJECT_SUB_COMPONENT_SUCCESS = 'CREATE_PROJECT_SUB_COMPONENT_SUCCESS';
export const CREATE_PROJECT_SUB_COMPONENT_FAILURE = 'CREATE_PROJECT_SUB_COMPONENT_FAILURE';

export const OPEN_PROJECT_COMPONENT_FORM = "OPEN_PROJECT_COMPONENT_FORM";
export const CLOSE_PROJECT_COMPONENT_FORM = "CLOSE_PROJECT_COMPONENT_FORM";


export const OPEN_PROJECT_SUB_COMPONENT_FORM = "OPEN_PROJECT_SUB_COMPONENT_FORM";
export const CLOSE_PROJECT_SUB_COMPONENT_FORM = "CLOSE_PROJECT_SUB_COMPONENT_FORM";

// Getting project
export const GET_PROJECT_SUB_COMPONENTS_START = "GET_PROJECT_SUB_COMPONENTS_START";
export const GET_PROJECT_SUB_COMPONENTS_SUCCESS = "GET_PROJECT_SUB_COMPONENTS_SUCCESS";
export const GET_PROJECT_SUB_COMPONENTS_FAILURE = "GET_PROJECT_SUB_COMPONENTS_FAILURE";
